import { FC } from 'react';

const NoFolders: FC = () => (
  <div className="empty-state">
    <svg
      className="empty-state__icon"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12V38C4 40.2091 5.79086 42 8 42H40C42.2091 42 44 40.2091 44 38V16C44 13.7909 42.2091 12 40 12H24L20 6H8C5.79086 6 4 7.79086 4 10V12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
    <p className="empty-state__text">No folders yet</p>
    <span className="empty-state__subtext">
      Create a folder to organize your documents
    </span>
  </div>
);

export default NoFolders;
